import { render } from "./reviewSubmit.vue?vue&type=template&id=0e13723f&scoped=true"
import script from "./reviewSubmit.vue?vue&type=script&lang=js"
export * from "./reviewSubmit.vue?vue&type=script&lang=js"

import "./reviewSubmit.vue?vue&type=style&index=0&id=0e13723f&lang=sass&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e13723f"]])

export default __exports__